// `text.ad_copy`: live's AI-generated ad copies (G8, #217).
// Live's "Ad copies": its modal writes them, not a Studio draft.
import { TextAdCopyQuote, TextAdCopyRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields } from "./shared";

export const jobType: JobTypeModule<"text.ad_copy"> = {
  type: "text.ad_copy",
  label: "Ad copies",
  source: "form",
  pair: "text.ad_copy",
  fields: (draft) => commonFields(draft),
  request: TextAdCopyRequest,
  quote: TextAdCopyQuote,
};
